var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: { title: "NOVA CIDADE", subtitle: "Cadastre uma nova cidade" },
      on: {
        close: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c("template", { slot: "body" }, [
        _c("div", { staticClass: "form-group" }, [
          _c(
            "div",
            { staticClass: "input-group" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.display_name,
                    expression: "display_name"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required",
                    expression: "'required'",
                    modifiers: { disable: true }
                  }
                ],
                staticClass: "capitalize",
                class: { "has-error": _vm.errors.has("display_name") },
                attrs: {
                  id: "city_name",
                  name: "display_name",
                  type: "text",
                  placeholder: ".",
                  "data-vv-as": "nome"
                },
                domProps: { value: _vm.display_name },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.display_name = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "city_name" } }, [_vm._v("nome")]),
              _vm._v(" "),
              _vm.errors.has("display_name")
                ? _c("ErrorInput", {
                    attrs: { message: _vm.errors.first("display_name") }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-group" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.code,
                    expression: "code"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required|max:10",
                    expression: "'required|max:10'",
                    modifiers: { disable: true }
                  }
                ],
                staticClass: "capitalize",
                class: { "has-error": _vm.errors.has("code") },
                attrs: {
                  id: "city_code",
                  name: "code",
                  type: "text",
                  placeholder: ".",
                  maxlength: "10",
                  "data-vv-as": "codigo"
                },
                domProps: { value: _vm.code },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.code = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "city_code" } }, [_vm._v("codigo")]),
              _vm._v(" "),
              _vm.errors.has("code")
                ? _c("ErrorInput", {
                    attrs: { message: _vm.errors.first("code") }
                  })
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c(
            "div",
            { staticClass: "input-group" },
            [
              _c("v-selectpage", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required",
                    expression: "'required'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "code",
                  "data-vv-as": "estado",
                  data: _vm.states,
                  title: "Estado",
                  placeholder: "estado",
                  "key-field": "id",
                  "show-field": "name"
                },
                model: {
                  value: _vm.state_id,
                  callback: function($$v) {
                    _vm.state_id = $$v
                  },
                  expression: "state_id"
                }
              }),
              _vm._v(" "),
              _vm.errors.has("code")
                ? _c("ErrorInput", {
                    attrs: { message: _vm.errors.first("code") }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [
        _c(
          "button",
          {
            staticClass: "btn bg-purple-outline",
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_vm._v("\n      fechar\n    ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn bg-purple",
            class: { "btn--loading": _vm.preloader },
            on: { click: _vm.submit }
          },
          [_c("span", [_vm._v("cadastrar")])]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ca85fc16", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca85fc16","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cities/NewCity.vue
// module id = null
// module chunks = 